export default {"src":"/_next/static/media/coin-circle-fill.ef4b71cf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};